
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M43.86,13.46H37.64V11.82a4.46,4.46,0,0,0-4.45-4.46H26.82a4.47,4.47,0,0,0-4.47,4.46v1.64H16.14a2.47,2.47,0,0,0-2.47,2.48V17a2.47,2.47,0,0,0,2.47,2.47H43.86A2.47,2.47,0,0,0,46.33,17v-1.1A2.47,2.47,0,0,0,43.86,13.46Zm-10.22,0H26.35V11.82a.47.47,0,0,1,.47-.46h6.37a.46.46,0,0,1,.45.46Z"}}),_c('path',{attrs:{"d":"M43.05,21.07H17a2.48,2.48,0,0,0-2.48,2.47l4.1,26.63a2.47,2.47,0,0,0,2.48,2.47H39a2.47,2.47,0,0,0,2.47-2.47l4.11-26.63A2.48,2.48,0,0,0,43.05,21.07ZM27.63,44.35a1.16,1.16,0,1,1-2.31,0v-15a1.16,1.16,0,1,1,2.31,0Zm7.05,0a1.16,1.16,0,1,1-2.31,0v-15a1.16,1.16,0,1,1,2.31,0Z"}})])])
          )
        }
      }
    